$(function() {
    var headerH = $('header').outerHeight();
    var winW;
    var width = 767;
    //resize
    function setTopSize() {}
	setTopSize.prototype.top = function() {
        winW = $(window).width();
        winH = $(window).outerHeight();
        $('.journal .contentsKv').css({height : winH - headerH});
	}
	var resize = new setTopSize();
	$(window).resize(function() {
		resize.top();
	});
	resize.top();

    if(winW < 767) {
        //journalTop journal__list
        $('.journalTop .btn--text > p').on({'click':function(){
            $('.journalTop .journal__list > li:nth-child(n+9)').slideToggle(300);
            $(this).parent('.btn--text').toggleClass('disable');
            return false;
            }
        });
    } else {
        $('.journalTop .btn--text > p').on({'click':function(){
            $('.journalTop .journal__list > li:nth-child(n+10)').slideToggle(300);
            $(this).parent('.btn--text').toggleClass('disable');
            return false;
            }
        });
    }

    $('.searchSlick--journal').slick({
        infinite: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        responsive:  [{
          breakpoint: 767,
          settings: {
            slidesToShow: 2
          }
         }],
    });

});
